import {
    SIGN_IN_SUCCEEDED,
    SIGN_OUT_SUCCEEDED,
    FETCH_ACCOUNT_SUCCEEDED,
    FETCH_ORGANIZATION_SETTINGS_SUCCEEDED,
    UPDATE_AUTO_PROGRESS_SUCCEEDED,
    SAVE_DEFAULTS_SUCCEEDED,
    UPLOAD_ORGANIZATION_LOGO_SUCCEEDED,
} from 'shared_redux/actions';

import {
    UPDATE_ORGANIZATION_NAME_SUCCESS,
} from 'features/settings/staff/actions';

import { Model, fk, many, attr } from 'redux-orm';

// this assumes a single organization ever for simplicity
class Organizations extends Model {

    static reducer(action, Organizations, session) {
        switch (action.type) {
            case SIGN_IN_SUCCEEDED: {
                const copy = action.payload.organization;
                console.log('[Organizations Reducer] SIGN_IN_SUCCEEDED - Organization from backend:', copy);
                console.log('[Organizations Reducer] Full payload:', action.payload);
                delete copy.organization_settings['organization_id'];

                // Clear all existing organizations first to ensure we use the one from backend
                Organizations.all().delete();

                // Insert the organization from backend as the current one
                const newOrg = Organizations.create({
                    ...copy,
                });

                localStorage.setItem('organizations', JSON.stringify(newOrg.ref));
                
                // CRITICAL: Update selectedOrganizationId to match the organization the backend determined we should use
                // This ensures API calls use the correct org ID that matches the backend's decision
                localStorage.setItem('selectedOrganizationId', copy.id);
                console.log('[Organizations Reducer] Updated selectedOrganizationId to:', copy.id);
                break;
            }
            case FETCH_ACCOUNT_SUCCEEDED: {
                // Handle organization updates when account is fetched (e.g., after accepting staff invitations)
                if (action.payload.organization) {
                    const copy = action.payload.organization;
                    console.log('[Organizations Reducer] FETCH_ACCOUNT_SUCCEEDED - Organization from backend:', copy);
                    delete copy.organization_settings['organization_id'];

                    // Clear all existing organizations first to ensure we use the updated one from backend
                    Organizations.all().delete();

                    // Insert the organization from backend as the current one
                    const newOrg = Organizations.create({
                        ...copy,
                    });

                    localStorage.setItem('organizations', JSON.stringify(newOrg.ref));
                    
                    // CRITICAL: Update selectedOrganizationId to match the organization the backend determined we should use
                    // This ensures API calls use the correct org ID that matches the backend's decision
                    localStorage.setItem('selectedOrganizationId', copy.id);
                    console.log('[Organizations Reducer] Updated selectedOrganizationId to:', copy.id);
                }
                break;
            }
            case FETCH_ORGANIZATION_SETTINGS_SUCCEEDED:
            case UPDATE_AUTO_PROGRESS_SUCCEEDED:
            case SAVE_DEFAULTS_SUCCEEDED: {
                const copy = action.payload;
                delete copy['organization_id'];
                const orig = Organizations.first(); // Use first() instead of withId(0)
                if (!orig) {
                    console.warn('Organization with ID 0 not found, skipping settings update');
                    break;
                }
                orig.update({
                    organization_settings: {
                        ...orig.organization_settings,
                        ...action.payload,
                    }
                });
                localStorage.setItem('organizations', JSON.stringify(Organizations.first().ref));
                break;
            }
            case UPDATE_ORGANIZATION_NAME_SUCCESS: {
                // Update the organization name in the store
                const updatedOrg = action.payload.organization;
                const current = Organizations.first();
                if (current && current.id === updatedOrg.id) {
                    current.update({
                        name: updatedOrg.name,
                    });
                    localStorage.setItem('organizations', JSON.stringify(current.ref));
                }
                break;
            }
            case UPLOAD_ORGANIZATION_LOGO_SUCCEEDED: {
                // Update the organization logo in the store
                const updatedOrg = action.payload;
                const current = Organizations.first();
                if (current && current.id === updatedOrg.id) {
                    current.update({
                        logo_url: updatedOrg.logo_url,
                    });
                    localStorage.setItem('organizations', JSON.stringify(current.ref));
                }
                break;
            }
            case SIGN_OUT_SUCCEEDED:
                Organizations.all().delete();
                localStorage.removeItem('organizations');
                break;
        }
    }
}
Organizations.modelName = 'Organizations';

Organizations.fields = {
    name: attr(),
    timezone: attr(),
    type: attr(),
    primary_color: attr(),
    secondary_color: attr(),
    destructive_color: attr(),
    nav_background_color: attr(),
    nav_text_color: attr(),
    nav_active_color: attr(),
    logo_url: attr(),
    organization_settings: attr(),
};

export default Organizations;
